import { MfeEventName } from "@/shared/constants/event.const";

/**
 * Emits a custom event that bubbles up and crosses shadow DOM boundaries
 * to reach the host application.
 *
 * @param element - Any element within the MFE (event will bubble up)
 * @param eventName - The event name from MFE_EVENTS
 * @param detail - Optional payload to send with the event
 */
export const emitMfeEvent = <T = unknown>(
  element: HTMLElement,
  eventName: MfeEventName,
  detail?: T,
): void => {
  element?.dispatchEvent(
    new CustomEvent(eventName, {
      bubbles: true,
      composed: true,
      detail,
    }),
  );
};
